<div class="absolute inset-0 flex flex-col items-center p-2 pt-16 gap-4">
  <div class="w-full">
    <app-adicionar-demanda-steps [activeStep]="adicionarDemandaState.activeStep()"/>
  </div>
  @if (adicionarDemandaState.activeStep() === 0) {
    @if (!showSelectTipoObraDialog && !showAlertaSelecioneTipoObra()) {
      <div class="absolute top-30 left-2 z-10 w-1/4 p-2 rounded bg-[#F5F5F7] shadow">
        <app-input-select-tipo-obra labelClass="text-[#494949] text-sm font-medium" class="pt-2"
                                    [initialValue]="selectedTipoObraId()"
                                    (selectionChange)="onFilterByTipoObra($event)"/>

      </div>
    }
    @if (isMapaCarregado()) {
      <google-map
        (mapClick)="handleMapClick($event)"
        (mapInitialized)="onMapInitialized($event)"
        [center]="center"
        [mapId]="mapId"
        [options]="mapOptions"
        [zoom]="zoom"
        class="absolute inset-0 w-full h-full pt-28"
        height="100%"
        width="100%"
      >
        @for (pin of pinsFiltrados(); track pin.title) {
          <map-advanced-marker
            [position]="pin.position"
            [title]="pin.title"
            [content]="pin.content"
          />
        }
        @if (posicaoPinSelecionado()) {
          <map-advanced-marker
            [position]="posicaoPinSelecionado()!"
            [content]="pinSelecionadoContent()"
          />
        }
      </google-map>
    }
  } @else {
    <div class="content-outlet flex-1 w-full min-h-0 overflow-y-auto py-2">
      <router-outlet/>
    </div>
  }
</div>

@if (showAlertaSelecioneTipoObra() && adicionarDemandaState.activeStep() === 0) {
  <app-dialog
    [closable]="false"
    [(visible)]="showAlertaSelecioneTipoObra"
    [headerTitle]="'Selecione o Tipo de Obra e Localização'"
    width="40vw"
  >
    <div class="text-md break-words">Selecione o tipo de obra, clique no local de sua demanda.</div>
    <div class="flex justify-end" footer>
      <p-button label="OK" styleClass="btn-red"
                (onClick)="showAlertaSelecioneTipoObra.set(false); showSelectTipoObraDialog = true;"
                (keydown.enter)="$event.preventDefault(); showAlertaSelecioneTipoObra.set(false); showSelectTipoObraDialog = true;"
                (keydown.space)="$event.preventDefault(); showAlertaSelecioneTipoObra.set(false); showSelectTipoObraDialog = true;">
      </p-button>
    </div>
  </app-dialog>
}

@if (showSelectTipoObraDialog) {
  <app-selecionar-tipo-obra-dialog
    (tipoObraSelected)="onSelectTipoObra($event)"
    [(visible)]="showSelectTipoObraDialog"
  />
}

@if (showAlertaLocalizacaoDuplicadaRaioTipoObra) {
  <app-dialog
    [(visible)]="showAlertaLocalizacaoDuplicadaRaioTipoObra"
    [headerTitle]="'Atenção!'"
    [closable]="false"
    [draggable]="false"
    width="40vw"
  >
    <div class="flex flex-col gap-3">
       <span>Não é possível cadastrar uma nova demanda do mesmo tipo de obra dentro do raio definido,
      pois já existe outra registrada nessa área.</span>
      <span>Para prosseguir, selecione outro tipo de obra ou ajuste a localização.</span>
    </div>

    <div class="flex gap-6" footer>
      <div class="flex justify-end gap-2">
        <p-button label="Fechar" (onClick)="showAlertaLocalizacaoDuplicadaRaioTipoObra = false;"
            (keydown.enter)="$event.preventDefault(); showAlertaLocalizacaoDuplicadaRaioTipoObra = false;"
            (keydown.space)="$event.preventDefault(); showAlertaLocalizacaoDuplicadaRaioTipoObra = false;"
                  styleClass="btn-outlined">
          <app-icon-bold-close-square color="currentColor"></app-icon-bold-close-square>
        </p-button>
      </div>
    </div>
  </app-dialog>

}

@if (showAlertaLocalizacaoForaArtesp) {
  <app-dialog
    [(visible)]="showAlertaLocalizacaoForaArtesp"
    [headerTitle]="'Atenção!'"
    [closable]="false"
    [draggable]="false"
    width="40vw"
  >
    <div class="flex flex-col gap-3">
      <span>Sua demanda está fora da malha de transportes fiscalizada pela ARTESP e, por isso, não pode ser criada.</span>
      <span>Para esses locais, entre em contato com o DER-SP.</span>
    </div>

    <div class="flex gap-6" footer>
      <div class="flex justify-end gap-2">
        <p-button label="Fechar" (onClick)="showAlertaLocalizacaoForaArtesp = false;"
            (keydown.enter)="$event.preventDefault(); showAlertaLocalizacaoForaArtesp = false;"
            (keydown.space)="$event.preventDefault(); showAlertaLocalizacaoForaArtesp = false;"
                  styleClass="btn-outlined">
          <app-icon-bold-close-square color="currentColor"></app-icon-bold-close-square>
        </p-button>
      </div>
    </div>
  </app-dialog>

}

@if (showDadosLocalizacaoDialog) {
  <app-dialog
    [(visible)]="showDadosLocalizacaoDialog"
    [headerTitle]="'Confirmar Localização'"
    width="40vw"
  >
    <div class="grid md:grid-cols-2 gap-2 w-full">
      <div class="flex flex-col gap-1">
        <span class="font-medium">Longitude</span>
        <span>{{ dadosLocalizacaoDemandaSelecionada()?.longitude }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="font-medium">Latitude</span>
        <span>{{ dadosLocalizacaoDemandaSelecionada()?.latitude }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="font-medium">Município</span>
        <span>{{ dadosLocalizacaoDemandaSelecionada()?.municipio }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="font-medium">Código da Rodovia</span>
        <span>{{ dadosLocalizacaoDemandaSelecionada()?.codRodovia }}</span>
      </div>
      <div class="flex flex-col gap-1">
        <span class="font-medium">Concessionária</span>
        <span>{{ dadosLocalizacaoDemandaSelecionada()?.concessionaria }}</span>
      </div>
    </div>
    <div class="flex gap-6" footer>
      <div class="flex justify-end gap-2">
        <p-button label="Escolher outro local"
                  (onClick)="showDadosLocalizacaoDialog = false;limparLocalizacaoSelecionada()"
                  (keydown.enter)="$event.preventDefault(); showDadosLocalizacaoDialog = false;limparLocalizacaoSelecionada()"
                  (keydown.space)="$event.preventDefault(); showDadosLocalizacaoDialog = false;limparLocalizacaoSelecionada()"
                  styleClass="btn-outlined">
          <app-icon-bold-close-square color="currentColor"></app-icon-bold-close-square>
        </p-button>
        <p-button label="Confirmar" styleClass="btn-red"
                  (onClick)="confirmarLocalizacaoDemandaSelecionada()"
                  (keydown.enter)="$event.preventDefault(); confirmarLocalizacaoDemandaSelecionada()"
                  (keydown.space)="$event.preventDefault(); confirmarLocalizacaoDemandaSelecionada()">
          <app-icon-checked-square color="currentColor"></app-icon-checked-square>
        </p-button>
      </div>
    </div>
  </app-dialog>
}
